<ng-container *ngIf="price?.availabilityMessage && showLeadTime">
  <img src="../../../../../../assets/icons/delivery_icon_black_24.svg" />
  <span>{{ price.availabilityMessage }}</span>
</ng-container>